export interface ResolveOfferFlashCancellationTimelineSurfaceParams {
  isDesktop: boolean
  isCancellationTimelineVariant: boolean
  hasFlexibleTimelineContext: boolean
}

export interface OfferFlashCancellationTimelineSurface {
  /**
   * Mount the desktop timeline experiment when the shared flexible context is available.
   */
  mountTimeline: boolean
  /**
   * Hide the flexible USP only when the timeline surface will actually take over.
   */
  suppressFlexibleUsp: boolean
}

/**
 * Single decision for offer-page cancellation timeline mount + USP dedupe.
 * Keep suppress tied to mount eligibility so variant users never lose both surfaces.
 */
export function resolveOfferFlashCancellationTimelineSurface(
  params: ResolveOfferFlashCancellationTimelineSurfaceParams,
): OfferFlashCancellationTimelineSurface {
  const mountTimeline = params.isDesktop && params.hasFlexibleTimelineContext

  return {
    mountTimeline,
    suppressFlexibleUsp: mountTimeline && params.isCancellationTimelineVariant,
  }
}
